export interface HeatmapTransforms {
  scaleX: number;
  scaleY: number;
  translateX: number;
  translateY: number;
}

export const defaultTransforms: HeatmapTransforms = {
  scaleX: 0,
  scaleY: 0,
  translateX: 0,
  translateY: 0,
};

export const pressureTransforms: HeatmapTransforms = {
  scaleX: 0.8,
  scaleY: 0.9,
  translateX: -25,
  translateY: -50,
};

export const temperatureTransforms: HeatmapTransforms = {
  scaleX: 0.81,
  scaleY: 0.89,
  translateX: -50,
  translateY: -40,
};
